export default __webpack_public_path__ + "static/media/preferedvendor_5.f3d0759b.png";